import { DatePicker, Select, Skeleton } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import HTTP from "../../services/httpService";
import { disableFutureDates } from "../../services/util";
import { DualAxisLineChart, FilterBar } from "./chartUtils";
dayjs.extend(customParseFormat);

const { Option } = Select;

function AssigneeTimeLog({ projects }) {
    const [assignee, setAssignee] = useState([]);
    const [columnChartData, setColumnChartData] = useState([]);
    const [hiddenSeries, setHiddenSeries] = useState({});
    const [defaultYear, setDefaultYear] = useState(dayjs());
    const staff_id = localStorage.getItem("x-dashboard-staffid");
    const [defaultFormData, setDefaultFormData] = useState({
        assignee_id: "",
        staff_id,
        range_year: defaultYear.get("year"),
        project_id: "-1",
    });

    const { status, data: assigneeRes } = useQuery(
        "assignee",
        async () => await HTTP("/analytics/getJiraAssignees", { staff_id }),
    );

    const {
        status: columnChartStatus,
        data: columnChartDataRes,
        refetch,
    } = useQuery(
        "columnChart",
        async () =>
            await HTTP("/analytics/getJiraTimingByMonth", {
                ...defaultFormData,
            }),
        { enabled: false },
    );

    useEffect(() => {
        refetch();
    }, []);
    useEffect(() => {
        refetch();
    }, [defaultFormData]);

    useEffect(() => {
        if (status === "success") setAssignee(assigneeRes.data);
    }, [status, assigneeRes]);

    useEffect(() => {
        if (columnChartStatus === "success")
            setColumnChartData(columnChartDataRes.data);
    }, [columnChartStatus, columnChartDataRes]);

    function handleYearChange(_, dateString) {
        setDefaultYear(dateString === "" ? dayjs() : dayjs(dateString));
        setDefaultFormData((prev) => ({
            ...prev,
            range_year: dateString || dayjs().get("year"),
        }));
    }

    function handleProjectSelectionChange(e) {
        const project_id = e ? e.split("#")[0] : -1;
        setDefaultFormData((prev) => ({ ...prev, project_id }));
    }

    function handleAssigneeSelectionChange(e) {
        const assignee_id = e ? e.split("#")[0] : "";
        setDefaultFormData((prev) => ({ ...prev, assignee_id }));
    }

    // Recharts legend click to toggle series visibility
    function handleLegendClick(e) {
        const idx = e.dataKey; // index-based from keys array
        setHiddenSeries((prev) => ({ ...prev, [idx]: !prev[idx] }));
    }

    const isReady =
        columnChartStatus !== "loading" && columnChartStatus !== "idle";

    return (
        <>
            <FilterBar>
                <DatePicker
                    defaultValue={defaultYear}
                    onChange={handleYearChange}
                    picker="year"
                    allowClear={false}
                    disabledDate={disableFutureDates}
                    style={{ width: 120 }}
                />
                <Select
                    allowClear
                    showSearch
                    placeholder="Project"
                    onChange={handleProjectSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {projects.map((e) => (
                        <Option key={`${e.project_id}#${e.project_name}`}>
                            {e.project_name}
                        </Option>
                    ))}
                </Select>
                <Select
                    allowClear
                    showSearch
                    placeholder="Assignee"
                    onChange={handleAssigneeSelectionChange}
                    style={{ flex: 1, minWidth: 160 }}
                >
                    {assignee.map((e) => (
                        <Option key={`${e.assignee_id}#${e.assignee_name}`}>
                            {e.assignee_name}
                        </Option>
                    ))}
                </Select>
            </FilterBar>
            {isReady && columnChartData.length > 0 ? (
                <DualAxisLineChart
                    rawData={columnChartData}
                    height={420}
                    hiddenSeries={hiddenSeries}
                />
            ) : (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 10, width: "100%" }}
                />
            )}
        </>
    );
}

export default AssigneeTimeLog;
